//@flow
import { gql, graphql } from "react-apollo"
import type { SensorFormViewProps } from "../types"

const QUERY_SENSOR_DETAILS = gql`
  query GetSensorDetails($id: ID!) {
    sensor(id: $id) {
      id
      friendlyName
      stationName
      sim
      serialNumber
      environmental
      latitude
      longitude
    }
  }
`

const options = (props: SensorFormViewProps) => ({
  variables: {
    id: props.match.params.id
  }
})

const withSensorFormDetails = graphql(QUERY_SENSOR_DETAILS, {
  options,
  name: "details"
})

export default withSensorFormDetails



// WEBPACK FOOTER //
// ./src/Sensors/queries/withSensorFormDetails.js